<div class="main-layout" [class.main-layout--collapsed]="isCollapsed()">
  <app-sidebar></app-sidebar>

  <!-- Mobile backdrop: visible on small screens when sidebar is open -->
  <div class="main-layout__backdrop"
       aria-hidden="true"
       (click)="closeSidebar()">
  </div>

  <section class="main-layout__body">
    <app-topbar></app-topbar>
    <main class="main-layout__content">
      <router-outlet></router-outlet>
      <!-- Global back-to-top floating button (positioned fixed, always visible) -->
      <app-back-to-top></app-back-to-top>
    </main>
  </section>
</div>
